import { gql } from "@apollo/client";

export const LOAD_RESERVATION_OFFER = gql`
  mutation loadReservationOffer($loadReservationOfferInput: LoadReservationOfferInput!) {
    loadReservationOffer(input: $loadReservationOfferInput) {
      reservationOffer {
        accommodations {
          id
          guests {
            id
            personType
            age
          }
          checkIn
          checkOut
          ratePlan {
            id
          }
        }
      }
    }
  }
`;
